{
  "nav": {
    "submissions": "Envíos",
    "tenants": "Espacios de trabajo"
  },
  "submissions": {
    "title": "Envíos",
    "filters": {
      "status": "Estado",
      "statusSubmitted": "Pendiente de evaluación",
      "statusEvaluated": "Evaluado",
      "statusAll": "Todos",
      "tenant": "Espacio de trabajo",
      "tenantAll": "Todos los espacios",
      "respondent": "Destinatario",
      "respondentPlaceholder": "Buscar por correo del destinatario",
      "sort": "Orden",
      "oldestFirst": "Más antiguos primero",
      "newestFirst": "Más recientes primero"
    },
    "table": {
      "tenant": "Espacio de trabajo",
      "respondent": "Destinatario",
      "submitted": "Completado",
      "status": "Estado",
      "evaluation": "Evaluación",
      "self": "Autoperfil",
      "empty": "No se encontraron envíos."
    }
  },
  "evaluationState": {
    "draft": "Borrador",
    "published": "Publicada"
  },
  "detail": {
    "back": "Volver a envíos",
    "notFound": "No se encontró el envío.",
    "tenant": "Espacio de trabajo",
    "givenName": "Nombre(s)",
    "familyName": "Apellido(s)",
    "email": "Correo electrónico",
    "submitted": "Completado",
    "language": "Idioma",
    "selfAssignment": "Autoperfil",
    "briefHint": "El propósito del encargo: escribe la evaluación teniéndolo presente.",
    "matrix": "Matriz",
    "copyForAnalysis": "Copiar para análisis",
    "copyHint": "Copia la cuadrícula, sus totales y sus medidas de dispersión al portapapeles como datos estructurados.",
    "copied": "Cuadrícula copiada para análisis.",
    "copyFailed": "No se pudo copiar la cuadrícula al portapapeles.",
    "downloadData": "Descargar datos (.xlsx)",
    "downloadHint": "Las respuestas en bruto en el formato de tres conjuntos, la tabla cruzada que suman y la cuadrícula con sus agregados.",
    "downloadFailed": "No se pudo generar el libro de cálculo."
  },
  "editor": {
    "title": "Evaluación",
    "placeholder": "Escribe la evaluación…",
    "saving": "Guardando…",
    "savedAt": "Guardado a las {{time}}",
    "saveDraft": "Guardar borrador",
    "publish": "Publicar",
    "publishConfirmTitle": "¿Publicar esta evaluación?",
    "publishConfirmDescription": "Al publicar se notifica al espacio de trabajo y al destinatario, y no se puede deshacer.",
    "publishOptions": "Más opciones de publicación",
    "publishSilently": "Publicar sin notificar",
    "publishSilentlyConfirmTitle": "¿Publicar esta evaluación sin notificar?",
    "publishSilentlyConfirmDescription": "No se notificará a nadie, ni por correo ni en la aplicación. Úsalo solo para una evaluación que ya se envió al espacio de trabajo por otro medio. La publicación no se puede deshacer.",
    "published": "Publicada",
    "publishedAt": "Publicada el {{date}}",
    "publishedBy": "por {{name}}"
  },
  "tenants": {
    "title": "Espacios de trabajo",
    "table": {
      "name": "Nombre",
      "slug": "Slug",
      "locale": "Idioma predeterminado",
      "created": "Creado",
      "owners": "Propietarios",
      "users": "Usuarios",
      "submissions": "Envíos",
      "credits": "Créditos",
      "actions": "Acciones",
      "gifted": "{{granted}} de regalo",
      "empty": "No se encontraron espacios de trabajo."
    },
    "grant": {
      "action": "Regalar créditos",
      "title": "Regalar créditos a {{name}}",
      "description": "Regala créditos gratis a este espacio de trabajo. No se cobra ningún pago ni se emite factura. El motivo es solo para nuestros registros y nunca se muestra al espacio de trabajo.",
      "creditsLabel": "Créditos",
      "reasonLabel": "Motivo",
      "reasonPlaceholder": "p. ej. Prueba de ventas — Acme",
      "submit": "Regalar créditos",
      "success": "Créditos regalados."
    }
  }
}
